import { Component, Input } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-unblock-partner',
  templateUrl: './unblock-partner.component.html',
  styleUrls: ['./unblock-partner.component.css'],
})
export class UnblockPartnerComponent {
  @Input() partnerName!: string;

  constructor(private active: NgbActiveOffcanvas) {}

  cancel() {
    this.active.dismiss();
  }

  confirm() {
    this.active.close('confirmed');
  }
}
